import React from "react";

const UserContext = React.createContext({
  user: {
    email: null,
    name_first: "",
    name_last: "",
    role: ""
  }
});

export default UserContext;
